import { supabase } from '../lib/supabase';

const TABLE_NAME = 'client_notes';

// Get all notes for a client
export const getClientNotes = async (clientId) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('client_id', clientId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
};

// Get important notes for a client
export const getImportantClientNotes = async (clientId) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .select('*')
    .eq('client_id', clientId)
    .eq('is_important', true)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
};

// Create a new note
export const createClientNote = async (noteData) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .insert([noteData])
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Update a note
export const updateClientNote = async (noteId, updates) => {
  const { data, error } = await supabase
    .from(TABLE_NAME)
    .update(updates)
    .eq('id', noteId)
    .select()
    .single();

  if (error) throw error;
  return data;
};

// Delete a note
export const deleteClientNote = async (noteId) => {
  const { error } = await supabase
    .from(TABLE_NAME)
    .delete()
    .eq('id', noteId);

  if (error) throw error;
};

// Toggle important status
export const toggleNoteImportance = async (noteId, isImportant) => {
  return await updateClientNote(noteId, { is_important: isImportant });
};
